__turbopack_context__.v({
  "Content": "Invalid-module-scss-module__p_TOEq__Content",
  "Description": "Invalid-module-scss-module__p_TOEq__Description",
  "TitleContent": "Invalid-module-scss-module__p_TOEq__TitleContent",
});
